import { render, staticRenderFns } from "./Indicadores.vue?vue&type=template&id=ae822bba"
import script from "./Indicadores.vue?vue&type=script&lang=js"
export * from "./Indicadores.vue?vue&type=script&lang=js"
import style0 from "./Indicadores.vue?vue&type=style&index=0&id=ae822bba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports